import React, { useEffect} from "react";
import Typography from '@mui/material/Typography';
import Google from '../components/GoogleMaps';
import TablePage from './TablePage';
import { authenticatedFetch } from '../Helper/Fetch/fetch';
import {useSkidConfig, useSkidConfigDispatch} from '../components/AvailableSkids/SkidsProvider'
import {useSkidsWithConfig, useSkidsWithConfigDispatch} from '../components/AvailableSkids/skidsWithConfigProvider'
import {useTracker, useTrackerDispatch} from '../components/FetchTracker/FetchTrackerProvider'
import { useMsal } from "@azure/msal-react";
import { loginRequest, protectedResources } from "../authConfig";
import { getConfigurl } from "../Config/config.tsx";



const styles = {
    root: {
      display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: '24px',
        height: '100vh',
        overflow: 'auto',
    },
    mapContainer: {
        marginLeft: -22,
    },
    appBarSpacer: {
        minHeight: '30px',
    },
};
const fetchSkids = async(accounts, instance, skidDispatch, TrackerDispatch) =>{
const configURL = getConfigurl()
  var fetchURL = configURL+"/GetAvailableSkids"
        console.log(`Hello ${accounts[0].name} your email is: ${accounts[0].username}`)
        var params = {}
        const request = {
          scopes: protectedResources.whoami.scopes,
          account: accounts[0]
        }
    
        var req = authenticatedFetch(request,instance,params,fetchURL)
        console.log('instance:',instance)
        req.then(res => res.json())
        .then((data) =>{
          console.log("available skids: ", data.skids);
          skidDispatch({
            type:'addSkids',
            skids:data.skids
          })
          TrackerDispatch({
            type:'skid',
            value:true
          })
          
        })  
}
const fetchSkidsWithConfig = async(accounts, instance, skidDispatch, TrackerDispatch) =>{
  const configURL = getConfigurl()
  var fetchURL = configURL+"/GetAvailableSkidsWithConfig"
   var params = {}
        const request = {
          scopes: protectedResources.whoami.scopes,
          account: accounts[0]
        }  
  var req = authenticatedFetch(request,instance,params,fetchURL).then(
    res => res.json()).then((items)=>{
       console.log("available skids with config: ", items.skids);
          skidDispatch({
            type:'addSkidsWithConfig',
            skid:null,
            skids:items.skids
          })
          TrackerDispatch({
            type:'skidsWithConfig',
            value:true
          })
    })

}
function  HomePage()  {
    const { instance, accounts, inProgress } = useMsal();
    const SkidDispatch = useSkidConfigDispatch()
    const TrackerDispatch = useTrackerDispatch()
    const SkidWithConfigDispatch = useSkidsWithConfigDispatch()
    useEffect(()=>{
        if(accounts[0]){
          fetchSkids(accounts, instance, SkidDispatch, TrackerDispatch)
          fetchSkidsWithConfig(accounts, instance, SkidWithConfigDispatch, TrackerDispatch)
        }  
      },[accounts])
    return (
        <div style={{width:'100%'}}>
        <div style={styles.appBarSpacer} />
            <Typography variant="h4" gutterBottom component="h2" color="white">
            </Typography>
            <Typography component="div" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Google key={'google'}/>
            </Typography>
            <Typography variant="h4" style={styles.appBarSpacer} color="white" />
            <Typography component="div" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <TablePage />
            </Typography>
        </div>
    );
};
export default HomePage;